function log (level, message, args) {
  if (level && !message) {
    // We have a message but no level
    message = level
    level = 'info'
  }
  if (level && typeof message === 'object' && args === undefined) {
    // level is message and message is args
    args = message
    message = level
    level = 'info'
  }
  const { $store: { getters: { socket } } } = this
  socket.emit('log-event', { level, message, args })
}

function install (Vue) {
  Vue.prototype.$log = log
}

export default {
  install
}
